import React, { Fragment, useEffect, useState, useRef } from "react"
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeTags } from 'Core/hooks';
import { injectIntl } from 'react-intl';
import { Grid } from '@mui/material';
import GroupsList from 'Components/GroupsList';
import { TypeLayer } from 'Components/Map/providers/enums'
import MapObject from 'Components/Map/providers/mapObject'
import Preferences from 'Core/containers/Preferences';
import { Select, Button } from 'Components';
import { OrderData } from 'Core/data/Helpers';
import styles from 'Assets/sass/core/vars.scss';
import _ from 'lodash';
import { MenuComponent } from 'Components/Menu';
import Delete from '../geofenceDelete';
import { getMainTag, getTagsIdsArray } from 'Components/Map/utils';
import { Checkbox } from '@gpstrackit/gtc-react-controls';

/*********************************************************
 * Redux
*********************************************************/
import {
    hideGeofenceGroups,
    mapGetGeofenceTags,
    mapGeofencesOpenEditCreateModal,
    mapGeofenceOpenDeleteModal,
    savePreference,
    getPreferences,
    getLandmarksAndGeofences as getKmls
} from 'Redux/actions';

const ROWS_PER_PAGE = 25;

const GeofenceList = (props) => {

    const { intl } = props;
    const { messages } = intl;
    const [data, setData] = useState([])
    const [selectedItem, setSelectedItem] = useState(null);
    const [preferences, setPreferences] = useState()
    const [showMenu, setShowMenu] = useState({});
    const [selectedAll, setSelectedAll] = useState(false);
    const dispatch = useDispatch()
    const preferencesRef = useRef()
    const preferencesKey = 'realtimeMaps';

    /*********************************************************
     * Use selector
    *********************************************************/
    const loadedJsonFiles = useSelector(state => state.catalogsRealtimeRedux.loadedJsonFiles);
    const jsonGeofence = useSelector((state) => state.catalogsRealtimeRedux.geofences);
    const loadingGeofenceJson = useSelector((state) => state.catalogsRealtimeRedux.loadingGeofences);
    const { geofenceTags, geofenceTagsLoading } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);

    const { response, loadingResponse } = useSelector((state) => state.realtimeMapGeofenceDeleteModuleRedux);

    const { authenticatedId } = useSelector(state => state.securityRedux);
    const loadingPreference = useSelector(state => state.preferencesRedux.loadingPreference);
    const hiddenGeofenceGroups = useSelector(state => state.realtimeMapGeofenceModuleRedux.hiddenGeofenceGroups);

    const returnServer = useSelector(state => state.preferencesRedux.returnServer);
    const preferencesUser = useSelector(state => state.preferencesRedux.preferencesUser);

    const tags  = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags', 'color', 'parentId'] });
    const haveUntagged = !!(
        (jsonGeofence && Array.isArray(jsonGeofence) && jsonGeofence.some(item => {
            const tagsIds = getTagsIdsArray(item.tagsId);
            return (tagsIds.includes('-1') || tagsIds.length === 0);
        })) ||
        (tags && Array.isArray(tags) && tags.some(tag => tag.id === -1)) ||
        (!tags || tags.length === 0)
    );
            

    useEffect(() => {
        dispatch(mapGetGeofenceTags())
        if (loadedJsonFiles && !(loadedJsonFiles?.length > 0)) {
            dispatch(getKmls())
        }
    }, [])

    useEffect(() => {
        if (!loadingPreference) {
            dispatch(getPreferences({ entityName: "User", entityId: authenticatedId }));
        }
    }, [loadingPreference])

    useEffect(() => {
        if (preferencesUser) {
            let preferencesKeyTemp = preferencesUser.find(x => x.preferenceKey === preferencesKey);
            let preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}";
            preferencesJSON = JSON.parse(preferencesJSON);

            setPreferences(preferencesJSON)
        }
    }, [returnServer]);

    /*********************************************************
     * Use effect ot load landmarks by groups
    *********************************************************/
    useEffect(() => {
        let geofenceData = [];
        if (haveUntagged) {
            geofenceData.push({
                id: -1,
                name: messages['untagged'],
                color: styles.color_untagged,
                visible: true,
                open: true,
                items: []
            });
        }

        if (geofenceTags && geofenceTags.length > 0) {
            geofenceData.push(
                ...geofenceTags
                    .filter(item => item.id !== -1)
                    .map((item) => {
                    return {
                        ...item,
                        name: item.label,
                        visible: true,
                        open: true,
                        items: []
                    };
                })
            );

            if (preferences?.hiddenGeofenceGroups?.length) {
                geofenceData = geofenceData?.map(gf => {
                    if (preferences?.hiddenGeofenceGroups?.includes(gf?.id)) {
                        return {
                            ...gf,
                            visible: false
                        }
                    }
                    return gf;
                });
            }

            if (preferences?.condensedGeofenceTagIds?.length) {
                geofenceData = geofenceData?.map(gf => {
                    if (preferences?.condensedGeofenceTagIds?.includes(gf?.id)) {
                        return {
                            ...gf,
                            open: false
                        }
                    }
                    return gf;
                });
            }

            geofenceData.sort((a, b) => { //Order by Alphabetically
                // untagged is first
                if (a.id === -1) return -1;
                if (b.id === -1) return 1;

                // sort by name attribute
                if (a.name?.toString()?.toLowerCase() > b.name?.toString()?.toLowerCase()) return 1;
                if (b.name?.toString()?.toLowerCase() > a.name?.toString()?.toLowerCase()) return -1;
                return 0;
            });

            if (haveUntagged) {
                let untaggedGeofences = geofenceData?.find(item => item?.id == 0);
                if (untaggedGeofences) {
                    geofenceData = geofenceData.filter(item => item?.id != 0);
                    geofenceData?.unshift(untaggedGeofences);
                }
            }

            geofenceData = getItemsOnTags(geofenceData);
            setData(geofenceData);
        } else if (geofenceData && geofenceData.length > 0) {
            geofenceData = getItemsOnTags(geofenceData);
            setData(geofenceData);
        }
    }, [geofenceTags, preferences?.hiddenGeofenceGroups, preferences?.condensedGeofenceTagIds]);

    /*********************************************************
     * Use effect ot load landmarks by groups
    *********************************************************/
    useEffect(() => {
        if (data && data.length > 0 && jsonGeofence && jsonGeofence.length > 0) {
            const geofenceTagsData = getItemsOnTags(data);
            geofenceTagsData && geofenceTagsData?.length > 0 && setData([...geofenceTagsData]);
        }
    }, [jsonGeofence]);

    /*********************************************************
     * Add the geofences into the tags elements
    *********************************************************/
    const getItemsOnTags = (tags = []) => {
        if (!jsonGeofence || jsonGeofence?.length <= 0) return tags;

        const geofenceTagsData = [...tags];

        //add the untagged
        if (haveUntagged && !geofenceTagsData.find(item => item?.id == -1)) {
            geofenceTagsData.push({
                id: -1,
                name: messages['untagged'],
                color: styles.color_untagged,
                visible: true,
                open: true,
                items: []
            })
        }

        // Groups that have at least one geofence specifically assigned to them (not via -99)
        const groupsWithSpecificGeofences = new Set(
            jsonGeofence.flatMap(g => {
                if (!g.tagsId) return [];
                return g.tagsId.split(',').filter(id => id !== '-99' && id !== '-1' && id !== '0' && id !== '');
            })
        );
        const hasSpecificAssignments = groupsWithSpecificGeofences.size > 0;

        geofenceTagsData.forEach((item) => {
            let geofenceElements = jsonGeofence.filter((geofence) => {
                if (geofence?.tagsId) {
                    const tagsIds = geofence.tagsId.split(',');
                    // -1: untagged only | -99 (all tags): all groups if no specific assignments exist, otherwise only groups that have specific assignments
                    return tagsIds.includes(item.id.toString()) || (tagsIds.includes('-1') && item.id == -1) || (tagsIds.includes('-99') && item.id != -1 && (!hasSpecificAssignments || groupsWithSpecificGeofences.has(item.id.toString())));
                } else if (haveUntagged && item.id == -1) { //untagged
                    return true;
                }
                return false;
            });
            //find color null
            geofenceElements = geofenceElements.map((geofence) => {
                return {
                    ...geofence,
                    color: geofence.color ? geofence.color : item.color
                }
            });

            geofenceElements.sort((a, b) => { //Order by Alphabetically
                if (a.name?.toString()?.toLowerCase() > b.name?.toString()?.toLowerCase()) return 1;
                if (b.name?.toString()?.toLowerCase() > a.name?.toString()?.toLowerCase()) return -1;
                return 0;
            });

            item.items = [...geofenceElements]
        });

        // Remove tags that have no geofences assigned to improve performance
        const filteredItems = geofenceTagsData.filter(item => item.items.length > 0);
        geofenceTagsData.splice(0, geofenceTagsData.length, ...filteredItems);

        if (haveUntagged) {
            //order untagged in first place
            geofenceTagsData.sort((a, b) => {
                // untagged is first
                if (a.id === -1) return -1;
                // untagged is first
                if (b.id === -1) return 1;

                // sort by name attribute
                if (a.name?.toString()?.toLowerCase() > b.name?.toString()?.toLowerCase()) return 1;
                if (b.name?.toString()?.toLowerCase() > a.name?.toString()?.toLowerCase()) return -1;
                return 0;
            });
        }
        return geofenceTagsData;
    }

    /*********************************************************
     * Draw the landmarks into the map
    *********************************************************/
    const onItemClicked = (item) => {
        const isInfoBubbleOpened = props?.mapRef?.current?.getOpenInfoWindow();
        if (!_.isEqual(selectedItem, item) || !isInfoBubbleOpened) {
            setSelectedItem(item);
            const { coordinates } = item
            const radius = item.radius > 0 ? item.radius : 0
            const coordinatesCenter = radius > 0 && coordinates?.length ? [{ lat: parseFloat(coordinates[0]?.latitude || 0), lng: parseFloat(coordinates[0]?.longitude || 0) }] : coordinates
            const center = coordinatesCenter ? props.mapRef.current.centerByFitBounds(coordinatesCenter, radius) : null;
            if (center) {
                const mapObject = {
                    id: item?.id,
                    position: center,
                    label: item?.name,
                    icon: {
                        rotation: 0
                    },
                    layerName: TypeLayer.Geofence
                }
                props.mapRef.current.modalPopupEvent(mapObject, mapObject);
            }
            props.mapRef.current.removeLayer(TypeLayer.TemporalObjects);
            const tag = getMainTag(item, geofenceTags, true);
            props.mapRef.current.drawShapeObjectTempOnMap(item, tag, false);
        }
    }

    /*********************************************************
     * get the landmarks by petition / load the landmark items
     * into the tree
     *********************************************************/
    const onTitleContainerClicked = (groupId, expanded) => {
        onExpanded(groupId, expanded)
    }

    /*********************************************************
     * open or close the list items.
     *********************************************************/
    const onExpanded = (groupId, expanded) => {
        const geofenceTags = data.map(item => {
            if (item.id == groupId) {
                return {
                    ...item,
                    open: expanded
                }
            }
            return item;
        });

        setData([...geofenceTags]);

        const newgGeofenceTags = geofenceTags?.filter(i => !i.open);
        const newgGeofenceTagsIds = newgGeofenceTags?.map(i => i?.id);

        const preferenceValue = { ...preferences, condensedGeofenceTagIds: newgGeofenceTagsIds };
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: preferenceValue }));
        setPreferences(preferenceValue);
    }

    /*********************************************************
     * show the groups into the realtime maps (KML files)
     *********************************************************/
    const onGroupCheckChanged = (groupId, checked) => {
        const newGeofences = data.map(item => {
            if (item.id == groupId) {
                return {
                    ...item,
                    visible: checked
                }
            }
            return item;
        });

        setData([...newGeofences]);
        const hiddenGeofenceTags = newGeofences.filter(item => !item.visible);
        dispatch(hideGeofenceGroups(hiddenGeofenceTags));

        //Save in preferences
        let hiddenGeofenceTagIds = hiddenGeofenceTags.map(newGeofence => newGeofence?.id);
        const preferenceValue = { ...preferences, hiddenGeofenceGroups: hiddenGeofenceTagIds };
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: preferenceValue }));
        setPreferences(preferenceValue);
    }

    /*********************************************************
     * Expand all tags into the view
    *********************************************************/
    const onExpandSwitchAll = (checked) => {
        const dataTags = [...data]
        let geofenceData = dataTags.map((item) => {
            return {
                ...item,
                open: checked
            };
        })
        geofenceData.map((item) => {
            onExpanded(item.id, checked)
        })

        setData([...geofenceData])

        const preferenceValue = { ...preferences, geofenceExpandAll: checked };
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: preferenceValue }));
        setPreferences(preferenceValue);
    }

    /*********************************************************
     * Add the list with untagged groups
    *********************************************************/
    const getTags = () => {
        if (haveUntagged) {
            let tagItems = [];
            tagItems = [...tagItems, ...(geofenceTags || [])];
            tagItems = tagItems ? OrderData(tagItems, "name") : [];
            tagItems.unshift({
                id: -1,
                name: messages['untagged'],
                color: styles.color_untagged,
                visible: true,
                open: false,
                items: []
            })

            return tagItems;
        }

        return geofenceTags ? OrderData(geofenceTags, "name") : [];
    }

    const cleanSearch = () => {
        if (!props?.mapRef?.current) return
        //eval if modal open contains the geofence information
        // close modal to delete geofence
        props.mapRef.current.hideMarkerModal()
        //delete temporal geofence select
        props.mapRef.current.removeLayer(TypeLayer.TemporalObjects);
    }

    const onSelectedTags = (value) => {
        const excludeItems = [] //select all exclude items is empty
        if (!value) {
            //unselect all
            data.forEach((item) => {
                excludeItems.push(item.id)
            })
            dispatch(hideGeofenceGroups(data));
        } else {
            dispatch(hideGeofenceGroups([]));
        }
        setSelectedAll(value)

        //save value on preference
        const preferenceValue = { ...preferences, hiddenGeofenceGroups: excludeItems };
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: preferenceValue }));
        setPreferences(preferenceValue);
    }

    return (
        <Grid container spacing={2}>
            <Grid item sm={12}>
                <Preferences
                    ref={preferencesRef}
                    preferencesKey={preferencesKey}
                    onInitialPreferences={(data) => {
                        if (!preferences) {
                            setPreferences({ geofenceExpandAll: false, ...data });
                        }
                    }}>
                    <GroupsList
                        showSearch
                        useDelay
                        isExpandAll={false}
                        expandAllProp={preferences?.geofenceExpandAll || false}
                        messages={messages}
                        loading={geofenceTagsLoading || loadingGeofenceJson}
                        onItemClicked={onItemClicked}
                        onTitleContainerClicked={onTitleContainerClicked}
                        onGroupCheckChanged={onGroupCheckChanged}
                        groupsData={data}
                        messageNoItems={messages["maputilities_vehiclelist_no_items"]}
                        onExpanded={onExpanded}
                        onExpandSwitchAll={onExpandSwitchAll}
                        offset={0}
                        itemsPerPage={ROWS_PER_PAGE}
                        totalItems={data.length}
                        height={600}
                        bodyHeight="calc(100vh - 455px)"
                        overflowY="auto"
                        onMouseEnter={(item) => {
                            let newShowMenu = { ...showMenu };
                            newShowMenu[item?.id] = true;
                            setShowMenu(newShowMenu);
                        }}
                        onMouseLeave={(item) => {
                            let newShowMenu = { ...showMenu };
                            newShowMenu[item?.id] = false;
                            setShowMenu(newShowMenu);
                        }}
                        renderActions={(
                            <Fragment>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}>
                                    <Button
                                        type="icon"
                                        icon="add_box"
                                        tooltip={messages['add']}
                                        size="large"
                                        fontSize="inherit"
                                        onClick={() => {
                                            dispatch(mapGeofencesOpenEditCreateModal(true));
                                        }}
                                    />
                                    <div style={{ width: 200, paddingLeft: 50, whiteSpace: "nowrap" }}>
                                        <label
                                            style={{ textDecoration: 'underline', color: '#4b4b4b', cursor: 'pointer' }}
                                            className='vehicleList-showall-value'
                                            onClick={() => {
                                                onSelectedTags(true)
                                            }}
                                        >
                                            {messages['maputilities_vehiclelist_showAll']}
                                        </label>
                                        <label style={{ padding: 5 }}>{" | "}</label>
                                        <label
                                            style={{ textDecoration: 'underline', color: '#4b4b4b', cursor: 'pointer' }}
                                            className='vehicleList-showall-value'
                                            onClick={() => {
                                                onSelectedTags(false)
                                            }}>
                                            {messages['maputilities_vehiclelist_hiddenAll']}
                                        </label>
                                    </div>
                                </div>
                            </Fragment>
                        )}
                        renderItemActions={(item) => {
                            return (
                                <div>
                                    {
                                        showMenu[item?.id] &&
                                        <MenuComponent
                                            options={[
                                                messages['map_landmark_edit'],
                                                messages['map_landmark_delete']
                                            ]}
                                            icon={'more_vert'}
                                            className="context-menu"
                                            onClick={(type, value) => {
                                                if (type === messages['map_landmark_edit']) {
                                                    dispatch(mapGeofencesOpenEditCreateModal(true, value?.id));
                                                } else if (type === messages['map_landmark_delete']) {
                                                    dispatch(mapGeofenceOpenDeleteModal(true, [value]));
                                                }
                                            }}
                                            value={item}
                                        />
                                    }
                                </div>
                            )
                        }}
                        clearFilterAfterAction={response && !loadingResponse}
                    >
                    </GroupsList>
                </Preferences>
            </Grid>

            <Delete cleanSearch={cleanSearch} />
        </Grid>
    )
}

export default injectIntl(GeofenceList)
